import React from 'react'
import styled from 'styled-components'
import {KeyboardArrowRight, KeyboardArrowLeft} from '@mui/icons-material'
import IconButton from '@mui/material/IconButton'
import View from './View'

const Tabs = styled.div`
    max-width: ${props => props.size}px;
    overflow: hidden;
`

const Transform = styled.div`
    display: flex;
    transition: transform 450ms cubic-bezier(.55, 0, .1, 1);
    transform: ${props => `translate3d(${- (WIDTH + MARGIN) * props.visible}px, 0px, 0px)`};
`

const Container = styled.div`
    margin: 0 20px;
    display: flex;
    align-items: center;

    button {
        padding: 0;

        :first-child {
            margin-right: 10px;
        }

        :last-child {
            margin-left: 10px;
        }
    }

    > svg {
        font-size: 25px;
    }
`

const COUNT = 3
const STEP = 1
const MARGIN = 10
const WIDTH = 150

class Views extends React.Component {
    constructor(props) {
        super(props)

        this.container = React.createRef()

        this.onDragStart = this.onDragStart.bind(this)
        this.onDragMove = this.onDragMove.bind(this)
        this.onDragEnd = this.onDragEnd.bind(this)

        this.state = {
            index: props.index > props.views.length - COUNT ? Math.max(props.views.length - COUNT, 0) : props.index,
            order: []
        }

    }

    componentDidUpdate(props) {
        if (this.state.order.length) {
            this.setState({ order: [] })
        }

        if (this.props.index !== props.index) {
            this.setState({
                index: this.props.index > this.props.views.length - COUNT ?
                    Math.max(this.props.views.length - COUNT, 0) : this.props.index
            })
        }
    }

    getOrder(views, order) {
        if (!order.length) {
            return views
        } else {
            return views.sort((a, b) => {
                let indexA = order.indexOf(a.id)
                let indexB = order.indexOf(b.id)

                return indexA - indexB
            })
        }
    }

    onDragStart(e, id) {
        e.preventDefault()

        const header = document.querySelector('header')
        header.classList.add('reorder')

        const sections = document.querySelectorAll('section')
        sections.forEach(item => item.classList.add('reorder'))

        this.order = this.props.views.filter(view => !view.isGlobal).map(item => item.id)

        this.setState({
            id,
            order: [...this.order]
        })

        this.calculateDragParameters(e, id)
        this.calculateCoordinates(id)
        this.dragTab = document.querySelector(`[data-view='${id}']`)
        this.dragTab.style.opacity = '0.5'
        this.dragTab.style.zIndex = '1'

        document.addEventListener('mousemove', this.onDragMove)
        document.addEventListener('mouseup', this.onDragEnd)

        this.onDragMove(e)
    }

    onDragMove(e) {
        let left = e.pageX - this.drag.relX - this.drag.leftOffset

        if (this.drag.min > left) {
            left = this.drag.min
        }

        if (this.drag.max < left) {
            left = this.drag.max
        }

        this.dragTab.style.transform = `translate3d(${left}px, 0px, 0px)`

        const right = left + this.drag.cellWidth
        /* Compare left position with markers */
        if (this.drag.elLeft && left < this.drag.markerLeft) {
            this.swapColumns(this.drag.elLeft, false)
        } else if (this.drag.elRight && right > this.drag.markerRight) {
            this.swapColumns(this.drag.elRight, true)
        }
    }

    onDragEnd(e) {
        e.preventDefault()

        const header = document.querySelector('header')
        header.classList.remove('reorder')

        const sections = document.querySelectorAll('section')
        sections.forEach(item => item.classList.remove('reorder'))

        // const tabs = document.querySelectorAll('[data-view]')
        // tabs.forEach(item => item.style.transform = '')

        if (JSON.stringify(this.order) !== JSON.stringify(this.state.order)) {
            // const views = this.getOrder(this.state.views, this.order)
            this.setState({
                //draggableId: null,
                order: [...this.order]
                //views
            }, () => this.props.onReorderViews(this.order))

            const tabs = document.querySelectorAll('[data-view]')
            tabs.forEach(item => item.style.transform = '')

            //this.props.onReorderViews(this.order)
        } else {
            const tabs = document.querySelectorAll('[data-view]')
            tabs.forEach(item => item.style.transform = '')
        }

        document.removeEventListener('mousemove', this.onDragMove)
        document.removeEventListener('mouseup', this.onDragEnd)

        this.dragTab.style.opacity = ''
        this.dragTab.style.zIndex = ''
    }

    calculateDragParameters(e, draggableId) {
        const container = this.container.current.getBoundingClientRect()
        const cell = document.querySelector(`[data-view='${draggableId}']`).getBoundingClientRect()
        const min = container.left - cell.left
        const max = container.width - cell.width + min

        this.drag = {
            leftOffset: cell.left,
            min: min,
            max: max,
            relX: e.pageX - cell.left,
            cellWidth: cell.width
        }
    }

    calculateCoordinates(draggableId) {
        if (draggableId) {
            const itemPosition = this.order.indexOf(draggableId)

            /* Calculate Left Marker */
            this.drag.elLeft = null
            if (itemPosition) {
                this.drag.elLeft = this.order[itemPosition - 1]
                this.drag.markerLeft = this.getColumnMarker(this.drag.elLeft)
                if (!this.drag.markerLeft === null) {
                    this.drag.elLeft = null
                }
            }
            /* Calculate Right Marker */
            this.drag.elRight = null
            if (itemPosition !== this.order.length - 1) {
                this.drag.elRight = this.order[itemPosition + 1]
                this.drag.markerRight = this.getColumnMarker(this.drag.elRight)
                if (this.drag.markerRight === null) {
                    this.drag.elRight = null
                }
            }
        }
    }

    getColumnMarker(elId) {
        const el = document.querySelector(`[data-view='${elId}']`)
        if (el) {
            const box = el.getBoundingClientRect()
            return box.left - this.drag.leftOffset + (box.width / 2)
        }
        return null
    }

    swapColumns(targetId, direction) {
        const trgtEls = document.querySelector(`[data-view='${targetId}']`)
        const transform = (this.drag.cellWidth + MARGIN) * (direction ? -1 : 1)

        if (trgtEls.style.transform) {
            trgtEls.style.transform = ''
        } else {
            trgtEls.style.transform = `translate3d(${transform}px, 0px, 0px)`
        }

        const targetIndex = this.order.indexOf(targetId)
        this.order[this.order.indexOf(this.state.id)] = targetId
        this.order[targetIndex] = this.state.id

        this.calculateCoordinates(this.state.id)
    }

    nextTab = () => {
        this.setState(state => ({
            index: state.index + STEP
        }))
    }

    prevTab = () => {
        this.setState(state => ({
            index: state.index - STEP
        }))
    }

    render() {
        const views = this.getOrder(this.props.views, this.state.order)

        return (
            <Container>
                {this.props.views.length > COUNT &&
                    <IconButton onClick={this.prevTab} disabled={this.state.index < 1}>
                        <KeyboardArrowLeft />
                    </IconButton>
                }
                <Tabs ref={this.container} size={MARGIN * (COUNT - 1) + WIDTH * COUNT}>
                    <Transform visible={this.state.index}>
                        {views.map(item =>
                            <View
                                default={item.isGlobal}
                                key={item.id}
                                id={item.id}
                                handleSelectView={this.props.handleSelectView}
                                handleClick={this.props.handleOpen}
                                active={this.props.active === item.id}
                                icon={item.icon}
                                name={item.name}
                                permissions={this.props.permissions}
                                onDragStart={this.onDragStart}
                                size={WIDTH}
                                count={this.props.views.length}
                            />
                        )}
                    </Transform>
                </Tabs>
                {this.props.views.length > COUNT &&
                    <IconButton onClick={this.nextTab} disabled={this.state.index + COUNT === this.props.views.length}>
                        <KeyboardArrowRight />
                    </IconButton>
                }
            </Container>
        )
    }
}

export default Views
